import { Model } from 'pinia-orm';
import Application from './Application';
import User from './User';
import InterviewAnswer from './InterviewAnswer';
import TimelineEvent from './TimelineEvent';
import moment from 'moment';
import Subscription from "./Subscription";
import InterviewInvitation from "./InterviewInvitation";
import Location from "./Location";
import Timeslot from "./Timeslot";
import InterviewTimeslot from "./InterviewTimeslot";

export default class Interview extends Model {

    static entity = 'interviews';

    get timeMoment() {
        return moment(this.starts_at);
    }

    static fields() {
        return {
            id: this.uid(),
            location: this.attr(''),
            starts_at: this.attr(''),
            zoom_id: this.attr(null),
            application_id: this.attr(null),
            user_id: this.attr(null),
            selected_timeslot_id: this.attr(null),
            feedback: this.attr(''),
            country_id: this.attr(null),
            internal_notes: this.attr(''),
            type: this.attr(null),
            status: this.attr(null),
            has_bulk_timeslots: this.attr(false),
            street: this.attr(null),
            city: this.attr(null),
            postal_code: this.attr(null),
            meeting_url: this.attr(null),
            phone: this.attr(null),
            icsFilepath: this.attr(null),
            company_location_id: this.attr(null),
            name: this.attr(''),
            visibility: this.attr('all'),
            sync: this.boolean(true),
            users: this.attr([]),
            duration: this.attr(null),
            buffer: this.attr(null),
            instant: this.attr(null),
            created_at: this.attr(null),
            interviewee_reschedule_reason: this.attr(null),
            interviewee_cancel_reason: this.attr(null),
            mode: this.attr('manually'),
            calendar_open: this.attr(false),
            calendar_time_range: this.attr(null),

            user: this.belongsTo(User, 'user_id'),
            application: this.belongsTo(Application, 'application_id'),
            interview_answers: this.hasMany(InterviewAnswer, 'interview_id'),
            timeline_events: this.morphMany(TimelineEvent, 'eventable_id', 'eventable_type'),
            subscriptions: this.morphMany(Subscription, 'subable_id', 'subable_type'),
            invitation: this.hasOne(InterviewInvitation, 'interview_id'),
            company_location: this.belongsTo(Location, 'company_location_id'),
            timeslots: this.belongsToMany(Timeslot, InterviewTimeslot, 'interview_id', 'timeslots_id'),
            selected_timeslot: this.hasOne(Timeslot, 'selected_timeslot_id'),
        }
    }
}
